module.exports = __webpack_public_path__ + "components/MapControl/svg/Klub muzyczny.svg?1f3175db";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Klub muzyczny.svg
// module id = 2050
// module chunks = 0